const debug = process.env.NODE_ENV !== 'production' ;

export default debug ;
